import { action, observable, makeObservable, runInAction } from "mobx";
import api from "../../../../api";
import { Modal, message } from "antd";
import CommonStore from "../../common_store";

class APoolStore {
  @observable isEnable: string = "";
  //搜索表单字段
  @observable searchForm: powerSearchData = {};
  @observable tableData: any = {};
  //表格加载状态
  @observable tableLoad: boolean = true;
  //控制modal展开
  @observable open: boolean = false;
  @observable modalLoading: boolean = false;
  //分页信息
  @observable pageData: IPageData = {
    page: 1,
    size: 10,
    changePage: (page: number, size: number) => {
      runInAction(() => {
        this.pageData.page = page;
        this.pageData.size = size;
        this.pageData = { ...this.pageData };
      });
      this.manageAPoolPage();
    },
  };
  @observable poolDetailData: any = [];

  @observable arrayTranslation: any = {
    readable: "查看",
    writable: "编辑",
    grantable: "授权",
    manageable: "管理",
  };

  commonStore: CommonStore;
  constructor(baseStore: CommonStore) {
    this.commonStore = baseStore;
    makeObservable(this);
  }

  setSearchForm(obj: powerSearchData) {
    runInAction(() => {
      this.searchForm = obj;
    });
  }

  //重置分页
  resetPage() {
    runInAction(() => {
      this.pageData.page = 1;
    });
  }

  @action
  manageAPoolPage() {
    runInAction(() => {
      this.tableData = {};
      this.tableLoad = true;
    });
    const data = { ...this.searchForm };
    data.size = this.pageData.size;
    data.page = this.pageData.page;
    api.aPoolAllocationApi
      .manageAPoolPage(data)
      .then((res: any) => {
        if (res.code == 200) {
          runInAction(() => {
            this.tableData = res.data;
            this.tableData = { ...this.tableData };
            this.tableLoad = false;
          });
          this.commonStore.getPagePermission("apool_management");
        }
      })
      .catch((e: any) => {
        runInAction(() => {
          this.tableLoad = false;
        });
      });
  }

  @action
  editAPool(data: any) {
    api.aPoolAllocationApi
      .editAPool({
        no: data.no,
        name: data.name,
      })
      .then((res: any) => {
        this.manageAPoolPage();
        message.success("编辑成功");
      })
      .catch((e: any) => {});
  }

  @action
  deleteAPool(groupNo: string) {
    api.aPoolAllocationApi
      .deleteAPool(groupNo)
      .then((res: any) => {
        message.success("删除成功");
        this.resetPage();
        this.manageAPoolPage();
      })
      .catch((e: any) => {});
  }

  deletePower(groupNo: string) {
    return new Promise((resolve, reject) => {
      Modal.confirm({
        centered: true,
        title: "确认删除",
        content: "您确定要删除该号池吗？",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          this.deleteAPool(groupNo);
          return resolve(true);
        },
        onCancel: () => {
          return false;
        },
      });
    });
  }

  @action
  addAPool(data: any) {
    api.aPoolAllocationApi
      .addAPool({
        name: data.name,
      })
      .then(async (res: any) => {
        this.resetPage();
        this.manageAPoolPage();
        message.success("新增成功");
      })
      .catch((e: any) => {});
  }

  @action
  setAPoolEnable(no: any, isEnable: any) {
    api.aPoolAllocationApi
      .setAPoolEnable({ no: no, isEnable: !isEnable })
      .then((res: any) => {
        message.success(isEnable ? "禁用成功" : "启用成功");
        this.manageAPoolPage();
      })
      .catch((e: any) => {});
  }
  @action changeIsEnable(isEnable: any, no: any) {
    this.isEnable = isEnable
      ? "您确定要禁用该号池吗？"
      : "您确定要启用该号池吗？";
    return new Promise((resolve, reject) => {
      Modal.confirm({
        centered: true,
        title: "确认启用/禁用",
        content: this.isEnable,
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          this.setAPoolEnable(no, isEnable);
          return resolve(true);
        },
        onCancel: () => {
          return false;
        },
      });
    });
  }

  showModal = (no: any) => {
    this.getAPoolDetail(no);
    runInAction(() => {
      this.open = true;
    });
  };
  hideModal = () => {
    runInAction(() => {
      this.open = false;
    });
  };

  @action
  getAPoolDetail(no: any) {
    runInAction(() => {
      this.modalLoading=true
    });
    api.aPoolAllocationApi
      .getAPoolDetail({ no: no })
      .then((res: any) => {
        runInAction(() => {
          this.poolDetailData = res.data;
          this.modalLoading=false
        });
      })
      .catch((e: any) => {
        runInAction(() => {
          this.modalLoading=false
        });
      });
  }
}

export default APoolStore;
